<template>
  <div>
    <Ruler :dpi="dpi" :fullScreen="fullScreen" @screenText="setScreenText" />

    <main class="lg:mt-6 max-w-3xl mx-auto">
      <router-link to="/" alt="OnlineRuler" title="OnlineRuler">
        <h1
          class="my-6 font-bold text-4xl lg:text-5xl bg-gradient-to-l from-blue-500 via-teal-500 to-green-500 text-transparent bg-clip-text"
        >
          📏 Online Ruler
        </h1>
      </router-link>
      <h2 class="text-lg md:text-2xl text-black mx-auto mb-0">
        Free <b>online ruler</b> tool for measuring inches (in), centimeters
        (cm) and millimeters (mm)!
      </h2>

      <button
        v-if="!fullScreen"
        @click="setFullScreen"
        type="button"
        class="mt-6 rounded-md bg-indigo-600 px-3 py-2 text-sm md:text-base font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <i class="fa fa-up-right-and-down-left-from-center text-xs mr-2" />
        Full Screen
      </button>
      <button
        v-else
        @click="setFullScreen"
        type="button"
        class="fs absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-md bg-indigo-600 px-3 py-2 text-sm sm:text-base font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        Exit Full Screen
      </button>

      <div id="screenInfo" class="mt-6 text-sm md:text-lg mx-auto">
        The ruler scales to actual size based on your screen size. Every device
        has a different pixel density, so we auto-detect your device and scale
        the ruler accordingly.
      </div>

      <div class="mt-6 text-sm md:text-base mx-auto">
        <b>Detected settings:</b>
        <p v-if="device">Device: {{ device.Name }}</p>
        <p v-html="screenText" />
      </div>
    </main>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import Ruler from "@/components/Ruler.vue";

let screenText = ref(null);
let fullScreen = ref(false);

export default {
  props: {
    dpi: Number,
    device: Object,
  },
  components: {
    Ruler,
  },
  methods: {
    setScreenText(d) {
      screenText.value = d;
    },
    setFullScreen() {
      fullScreen.value = !fullScreen.value;
    },
  },
  setup(props) {
    watch(
      () => props.dpi,
      (/*newVal, oldVal*/) => {
        screenText.value = `DPI: ${props.dpi}<br />Device pixel ratio:  ${
          window.devicePixelRatio
        }<br />
      Screen dimensions: ${Number(window.screen.height / props.dpi).toFixed(
        2
      )}" x ${Number(window.screen.width / props.dpi).toFixed(2)}" inches`;
      },
      { deep: true, immediate: true }
    );

    return {
      screenText,
      fullScreen,
    };
  },
};
</script>

<style scoped>
main {
  padding: 2rem;
}
@media (max-width: 768px) and (orientation: portrait) {
  main {
    margin-left: 120px;
  }
}
</style>